import React, { useEffect } from "react";
import { Redirect } from "react-router";

import { commonMessages } from "infrastructure/localization";
import { Splash } from "ui/app";
import { useLocalizedValues, useUserContext } from "ui/hooks";

export const SignedIn: React.FC = () => {
  const userContext = useUserContext();

  const localizedValues = useLocalizedValues(() => ({
    statusText: commonMessages.info("signInProcessing")
  }));

  useEffect(() => {
    if (!userContext.isAuthenticated()) {
      if (!userContext.hasError()) {
        userContext.completeSignIn();
      }
    }
  }, [userContext]);

  if (userContext.isAuthenticated()) {
    return <Redirect to={userContext.popPostSignInUri()} />;
  } else {
    if (userContext.hasError()) {
      return <Redirect to="/signin" />;
    } else {
      return <Splash statusText={localizedValues.statusText} />;
    }
  }
};
